import type { ApiClient } from '../client';
import { BoxStatusSchema, type BoxStatus } from '../schemas/boxStatus';

// Read the situation of a «buzón» RELATIVE TO one delivery. Box-first, the orientation the box log
// set: the box id rides the path, the delivery on screen rides the query string as the reference for
// «posterior» and for the «caso propio» exclusion — the same box answers differently for two of its
// deliveries. Both ids are url-encoded; the client attaches the Firebase token.
export async function fetchBoxStatus(
  client: ApiClient,
  boxId: string,
  deliveryId: string,
): Promise<BoxStatus> {
  const data = await client.get<unknown>(
    `/app_service/panel/v1/boxes/${encodeURIComponent(boxId)}/status` +
      `?delivery_id=${encodeURIComponent(deliveryId)}`,
  );
  return BoxStatusSchema.parse(data);
}
